import React, { useEffect } from 'react';
import ReactDOM from 'react-dom';
import { useVariablesContext } from 'context/variables.context';
import { useCopyToClipboard } from 'react-use';

import { createGlobalStyle } from 'styled-components';

const GlobalStyle = createGlobalStyle`
  .LandbotFullpage {
    top: 77px !important;
    z-index: 1 !important;
  }
`;

export default function NativeLandbot(props) {
  const { variables } = useVariablesContext();

  useEffect(() => {
    const landbot = new Landbot.Fullpage({
      ...props.config,
      customData: variables,
    });
    return () => landbot.destroy();
  }, []);

  return <GlobalStyle />;
}

const ShareLinkComponent = ({ data }) => {
  const [
    { value, error, noUserInteraction },
    copyToClipboard,
  ] = useCopyToClipboard();
  const link = generateLink(data);

  return (
    <>
      <input
        className="input has-background-white mb-2"
        type="text"
        value={link}
        readOnly
      />
      <div className="buttons">
        <button
          className="button is-danger"
          onClick={() => copyToClipboard(link.toString())}
        >
          Copy link
        </button>
        <a
          className="button is-danger"
          href={link}
          target="_blank"
        >
          Open in a new tab
        </a>
      </div>
    </>
  );
};

window.generateLink = function generateLink(variables = {}) {
  const link = new URL(location.pathname, location.origin);
  Object.entries(variables).forEach(([key, value]) => {
    link.searchParams.append(key, value);
  });
  return link;
};

window.mountShareLink = function mountShareLink(element, data) {
  const container = element.querySelector('.MessageBubbleText');
  if ((container, data)) {
    setTimeout(() => {
      ReactDOM.render(<ShareLinkComponent data={data} />, container);
    }, 2000);
  }
};
